export const SELECT = 'select';
export const SELECT_SOURCE = 'select_source';
export const DATE_RANGE = 'date_range';
export const TEXT = 'text';
export const NUMBER = 'number';
export const NUMBER_RANGE = 'number_range';
